const Actions = require('../actions');
const Button = require('../../../../components/form/button.jsx');
const ControlGroup = require('../../../../components/form/control-group.jsx');
const React = require('react');
const ReactHelmet = require('react-helmet');
const ReactRouter = require('react-router-dom');
const Spinner = require('../../../../components/form/spinner.jsx');
const Store = require('./store');
const TextControl = require('../../../../components/form/text-control.jsx');
const UserIdentity = require('../../../../helpers/user-identity');


const Helmet = ReactHelmet.Helmet;
const Link = ReactRouter.Link;
const Redirect = ReactRouter.Redirect;


class ForgotPage extends React.Component {
    constructor(props) {
        super(props);

        this.input = {};
        this.state = Store.getState();
    }

    componentDidMount() {
        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

        if (this.input.email) {
            this.input.email.focus();
        }
    }

    componentWillUnmount() {

        this.unsubscribeStore();
    }

    onStoreChange() {

        this.setState(Store.getState());
    }

    handleSubmit(event) {

        event.preventDefault();
        event.stopPropagation();

        Actions.forgot({
            email: this.input.email.value()
        });
    }

    render() {
        if (UserIdentity._checkUserIdentity()) {
            return <Redirect to='/' push />;
        }
        const alerts = [];

        if (this.state.success) {
            alerts.push(<div key="success">
                <div className="alert alert-success">
                    If an account matched that address, an email will be sent with instructions.
                </div>
                <h4 className="sub-title">Have a Dining Power account? 
                    <Link to="/login"> Sign in</Link>
                </h4>
            </div>);
        }

        if (this.state.error) {
            alerts.push(<div key="danger" className="alert alert-danger">
                {this.state.error}
            </div>);
        }

        let formElements;

        if (!this.state.success) {
            formElements = <fieldset>
                <TextControl
                    ref={(c) => (this.input.email = c)}
                    name="email"
                    hideLabel={true}
                    placeholder="Email Address"
                    hasError={this.state.hasError.email}
                    help={this.state.help.email}
                    disabled={this.state.loading}
                />
                <ControlGroup hideLabel={true} hideHelp={true}>
                    <Button
                        type="submit"
                        inputClasses={{ 'full' : true, 'mtb16' : true }}
                        disabled={this.state.loading}>
                        Reset Password
                        <Spinner space="left" show={this.state.loading} />
                    </Button>
                    <h4 className="sub-title">Have a FOPARK account? 
                        <Link to="/login"> Sign in</Link>
                    </h4>
                </ControlGroup>
            </fieldset>;
        }

        return (
            <section className="login-register">
                <Helmet>
                    <title>Forgot Password</title>
                </Helmet>
                <div className="container">
                    
                    <div className="login-right equal">
                        <div className="custom-modal">
                            <div className="modal-dialog">
                                <div className="modal-content login-part">
                                    <div className="modal-header">
                                        <button type="button" className="close hide" data-dismiss="modal">&times;</button>
                                        <h4 className="modal-title">Reset Your Password</h4>
                                    </div>
                                    <div className="modal-body">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            {alerts}
                                            {formElements}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


module.exports = ForgotPage;



// WEBPACK FOOTER //
// client/pages/main/login/forgot/index.jsx